import React, { useState } from "react";
import QuestionMarkIcon from "assets/svgs/HelpMeBadge.svg";
import { Modal } from "react-bootstrap";
import CloseIcon from "assets/svgs/close-btn.svg";
import RichText from "components/rich-text";
import * as styles from "./style.mod.scss";

const VariantCategoryDetails = ({ content }) => {
  if (!content || !content?.showQuestion) return<></>;
  const [open, setOpen] = useState(false);
  const showModal = () => setOpen(true);
  const hideModal = () => setOpen(false);
  
  return (
    <div className={styles.variantCategorySection}>
      <a onClick={showModal} className={styles.variantCategoryIcon}><QuestionMarkIcon /><span><RichText blocks={content?.title} /></span></a>
      <Modal show={open} onHide={hideModal} className={styles.variantCategoryModule}>
        <CloseIcon className={`${styles.modalClose} ${styles.modalCloseDesktop}`} onClick={hideModal} />
        <Modal.Body>
          <div className={styles.modalContainer}>
            <RichText
              blocks={content?.text}
            />
          </div>
        </Modal.Body>
        <div className={styles.modalCloseContainer}>
          <CloseIcon className={`${styles.modalClose} ${styles.modalCloseResponsive}`} onClick={hideModal} />
        </div>
      </Modal>
    </div>
  );
};

export default VariantCategoryDetails;